import { useCallback } from "react";
import { Tabs } from "@shopify/polaris";


const DashboardActionTabs = ({ tabs, selectedTab, setSelectedTab }) => {

  const handleTabChange = useCallback((selectedTabIndex: number) => setSelectedTab(selectedTabIndex), []);

  return (
    <Tabs tabs={tabs} selected={selectedTab} onSelect={handleTabChange} fitted/>
  );
};

export default DashboardActionTabs;
